module.exports = __webpack_public_path__ + "static/media/poster.c0fb384a.jpg";